import * as React from 'react';

import { UitkLink } from 'uitk-react-link';
import { liveAnnounce } from 'uitk-react-utils';

import { ButtonTracked } from 'components/shared';
import { ActionType, FlightsListDisplayFilterItemType, FlightsSuggestedFilterItem } from 'types/shared';
import { useStores } from 'utility/hooks';

interface SuggestedFilterOfferActionProps {
  action: ActionType;
  filterItem: FlightsListDisplayFilterItemType;
  suggestedFilter: FlightsSuggestedFilterItem;
}

export const SuggestedFilterOfferAction = ({
  action,
  filterItem,
  suggestedFilter
}: SuggestedFilterOfferActionProps) => {
  const { analytics, context, sortFilterStore, routeStore, advertisingStore, searchCriteriaStore } = useStores();
  const updateFilter = () => {
    sortFilterStore.applySortAndFilter(searchCriteriaStore, routeStore, advertisingStore, context, analytics);
  };

  const applyFilter = (e: MouseEvent) => {
    e.preventDefault();
    filterItem.selected = true;
    sortFilterStore.increaseAppliedFilterCount();
    updateFilter();
    liveAnnounce(suggestedFilter.accessibility.onCompletion);
  };

  return (
    <UitkLink key={`suggested-filter-${suggestedFilter.type}`}>
      <ButtonTracked
        linkName={action.analytics.linkName}
        rfrr={action.analytics.rfrr}
        onClick={applyFilter}
        data-test-id="suggested-filter-link"
        aria-label={suggestedFilter.accessibility && suggestedFilter.accessibility.usage}
      >
        {action.displayAction}
      </ButtonTracked>
    </UitkLink>
  );
};
